import React from 'react';
import Modal from '../Modal/Modal';
import PickupBody from './PickupBody';
import './styles.scss';

export default function PickupModal({
  isModalOpen,
  closeModal,
  selectPickup,
  pickupSource
}) {
  if (!isModalOpen) return null

  return (
    <Modal modalClassName="shipping-modal" onClose={closeModal}>
      <PickupBody closeModal={closeModal} selectPickup={selectPickup} pickupSource={pickupSource} withSelectCity={Boolean(pickupSource)} />
    </Modal>
  );
}
